import { Bar } from 'react-chartjs-2';
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  ChartData,
  ChartOptions,
  LinearScale,
  Tooltip,
} from 'chart.js';

import { getChartOptions } from '../helpers';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip);

type BarStackedChartProps = {
  data: ChartData<'bar'>;
};

export const BarStackedChart = ({ data }: BarStackedChartProps) => {
  const options: ChartOptions<'bar'> = getChartOptions('value', 'bar');

  return <Bar data={data} options={options} />;
};
